export default "__VITE_ASSET__BPMeyiUe__"